import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

// ======= Delete Iranian Accounts =======
export function deleteIranianAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/bank-accounts/iranian/${accountId}`)
}

export function deleteIranianSrcAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/bank-accounts/iranian-src/${accountId}`)
}

// ======= Delete International Accounts =======
export function deleteInternationalAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/bank-accounts/international/${accountId}`)
}

export function deleteInternationalRevolutAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/bank-accounts/international-revolut/${accountId}`)
}

export function deleteInternationalPaypalAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/bank-accounts/international-paypal/${accountId}`)
}
export function deleteInternationalWiseAccountAction(accountId: string): Promise<ApiResponse<null>> {
  return api.v2.delete<ApiResponse<null>>(`/bank-accounts/international-wise/${accountId}`)
}
